import getAgendaStore from '../store/store';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { defaultPropertyUpdater } from 'mini-agenda/lib/utils/isActiveTimerUtils';
import { mutatorAction } from 'satcheljs';
import { now, getTimestamp } from 'owa-datetime';

export const updateOngoingAgendaItemId = mutatorAction(
    'updateOngoingAgendaItemId',
    (ongoingItemId: string) => {
        const store = getAgendaStore();
        store.ongoingItemId = ongoingItemId;
    }
);

export const updateUpcomingAgendaItemId = mutatorAction(
    'updateUpcomingAgendaItemId',
    (upcomingItemId: string, upcomingEventStartTime?: number) => {
        const store = getAgendaStore();
        store.upcomingItemId = upcomingItemId;
        store.upcomingEventStartTime = upcomingEventStartTime;
    }
);

/**
 * Action updates the number of minutes remaining for an upcoming item, so that the corresponding clock is also updated
 */
export const updateRemainingMinutes = mutatorAction(
    'updateRemainingMinutes',
    (expirationTimeStamp: number, upcomingItemId?: string) => {
        const store = getAgendaStore();
        if (store.upcomingItemId || upcomingItemId) {
            const curTimestamp: number = getTimestamp(now());

            if (expirationTimeStamp < curTimestamp) {
                store.minutesRemainingForUpcomingItem = 0;
            } else {
                store.minutesRemainingForUpcomingItem =
                    Math.floor(expirationTimeStamp / TimeConstants.MillisecondsIn1Min) -
                    Math.floor(curTimestamp / TimeConstants.MillisecondsIn1Min);
            }
        } else {
            store.minutesRemainingForUpcomingItem = 0;
        }
    }
);

/**
 * Mutator action to update the timer for the agenda item
 */
export const updatePropertyForItem = mutatorAction(
    'updateTimerForAgendaItem',
    defaultPropertyUpdater
);
